import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

const Composite3 = ({ data }) => (
  <div className="composite__wrapper">
    <div className="composite" id="comp3">
      <div className="comp__image-wrapper" id="comp3-image1">
        <StaticImage
          src="../../assets/images/house-1.jpg"
          alt="This is the top left portion of a composite of four images that make up one image of Kate's childhood home. This portion of the composite shows a second-story window of the home, framed by dark shutters. To the left is another home, and in the foreground is an RV. Behind the RV towers a solitary tree. Power lines cross above the homes in front of a cloudy, gray sky."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp3-image2">
        <StaticImage
          src="../../assets/images/house-2.jpg"
          alt="This is the top right portion of a composite of four images that make up one image of Kate's childhood home. This portion of the composite shows the remainder of the upper part of Kate's home. A gray car and red truck are parked in a driveway just off a small paved road that ends in a T-intersection. Across the street is another home, and beyond the intersection is a blue warehouse with large white garage doors. Power lines cross above the homes in front of a cloudy, gray sky."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp3-image3">
        <StaticImage
          src="../../assets/images/house-3.jpg"
          alt="This is the bottom right portion of a composite of four images that make up one image of Kate's childhood home. This portion of the composite shows a lawn splotched with green and yellow grass. The bottom portion of a gray car can be seen parked in the driveway of the home, and the street in front of the home glistens as if it's slightly wet."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp3-image4">
        <StaticImage
          src="../../assets/images/house-4.jpg"
          alt="This is the bottom left portion of a composite of four images that make up one image of Kate's childhood home. This portion of the composite shows the lawn splotched with green and yellow grass. A small, concrete path, partially grown over by grass, is barely visible, leading to an empty spot in the lawn where Kate's garage used to be. Two metal posts, capped by a cross-beam, form a clothesline next to the path. A small brick barbecue pit, approximately 3-feet tall, sits beyond the clothesline. The bottom portion of the RV extends out of the top left of the image."
          width={900}
        />
      </div>
    </div>
    <p className="benton-n4 composite__caption">{data.caption}</p>
  </div>
);

Composite3.propTypes = {
  data: PropTypes.shape({
    caption: PropTypes.string.isRequired,
  }).isRequired,
};

export default Composite3;
